var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaBgMinimized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b{fill:#26337a}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e9e9e9",
    strokeMiterlimit: 10,
    strokeWidth: 0.533
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 32,
    stroke: "none",
    rx: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.467,
    height: 31.467,
    x: 0.267,
    y: 0.267,
    fill: "none",
    rx: 1.867
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.551 21.35l1.66-10.173h2.654l-1.66 10.173h-2.654M32.832 11.427A6.633 6.633 0 0030.454 11c-2.624 0-4.472 1.381-4.486 3.357-.018 1.463 1.317 2.278 2.323 2.764 1.034.5 1.382.817 1.378 1.262-.007.681-.825.994-1.589.994a5.371 5.371 0 01-2.5-.533l-.341-.162-.371 2.277a8.1 8.1 0 002.957.542c2.789 0 4.6-1.364 4.622-3.475.01-1.16-.7-2.038-2.229-2.764-.928-.472-1.497-.784-1.491-1.262 0-.423.481-.875 1.52-.875a4.7 4.7 0 011.986.391l.238.116.361-2.205M35.044 21.354h-2.787l3.941-9.324a1.311 1.311 0 011.392-.843h2.051l2.148 10.165h-2.464c0-.017-.247-1.188-.323-1.525h-3.399c-.1.274-.554 1.518-.558 1.53zm2.733-7.422c-.071.2-.165.45-.24.654-.083.225-.114.31-.114.314-.034.093-.845 2.278-1.057 2.842h2.2c-.1-.461-.526-2.517-.611-2.924v-.012zM18.324 11.186l-2.6 6.935-.278-1.41a7.838 7.838 0 00-3.674-4.266l2.377 8.9h2.809l4.179-10.159h-2.813",
    className: "b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec982d",
    d: "M13.315 11.179h-4.28L9 11.39a8.879 8.879 0 016.448 5.322l-.93-4.675a1.114 1.114 0 00-1.203-.858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaBgMinimized);
export default __webpack_public_path__ + "static/media/visa-bg-minimized.f57180ca.svg";
export { ForwardRef as ReactComponent };